import { getCardPropsMarkets, getCardPropsEventWithMbn, getSportConfig } from "../../../helpers";
import { getFixtureCardProps } from "../getFixtureCardProps";
//added tests webpack issue
/* istanbul ignore next */
export const getOutrightCardProps = (state, event, cms, dict) => {
    const sport = getSportConfig(event, state.isMiniEventCard, state.getCardConfiguration(event.sportId));
    const markets = getCardPropsMarkets(event, state.displayMarkets(event.id), sport);
    const ev = getCardPropsEventWithMbn(event, markets);
    const viewAllProps = state.deviceDetect.isDesktop
        ? {
            linkUrl: event.linkUrl,
            onClick: state.openGameTranspiler.bind(state, event)
        }
        : {};
    return event.isLive
        ? getFixtureCardProps(state, event, cms, dict)
        : {
            event: ev,
            markets,
            handlers: {
                betButton: state.addToSlipTranspiler.bind(state)
            },
            showHeadingNames: state.shouldShowOutrightSubheading,
            numberOfSelectionsToShow: state.preLiveOutrightShouldExpand
                ? markets[0].selections.length
                : cms.NumberOfSelectionsToShow,
            viewAllProps,
            hideLowOdds: cms.HideLowOdds,
            dict
        };
};
//# sourceMappingURL=getOutrightCardProps.js.map